export default __webpack_public_path__ + "static/media/18-dot-voting.5e9db7a3.svg";